class ToggleState {
  trigger;
  target;
  stateA;
  stateB;

  constructor(elemTrigger: Element, a: string, b: string) {
    this.trigger = document.querySelectorAll(`[data-trigger="${elemTrigger}"]`);
    this.target = document.querySelector(`[data-target="${elemTrigger}"]`);
    this.stateA = a;
    this.stateB = b;
    this._init();
  }

  _init() {
    this.trigger.forEach((element) => {
      element.addEventListener('click', () =>
        this.toggleState(this.stateA, this.stateB, element)
      );
    });
  }

  toggleState(one: string, two: string, element: Element) {
    const newState = element?.getAttribute('data-state') === one ? two : one;
    element?.setAttribute('data-state', newState);
  }
}

export default ToggleState;
